import React, { FC, useCallback } from 'react';
import TendersList from '../TendersList';
import styles from './index.module.scss';
import { FilterSearch, FilterSort, FilterStatuses } from 'src/shared';
import { Skeleton } from 'src/common';
import { useTendersViewState } from 'src/models/procurements/hooks';
import TendersBoard from '../TendersBoard';
import { useLoadAllMps } from 'src/models/matchingProfiles/hooks';
import EmptyMatchingProfilesList from '../TendersList/EmptyMessage/EmptyMatchingProfilesList';
import { PageView } from 'src/models/users/Preferences/types';
import { ApiTendersProvider } from 'src/models/procurements/Tenders/providers';
import OverviewSidebars from '../Sidebars';
import MpTitle from './MpTitle';
import { TendersTotal, ViewOptionsDropDown } from 'src/shared';
import { OverviewBoardActionsMultiple } from '../TendersBoard/ActionsMultiple';
import useSelectedTenders from 'src/reactiveVars/SelectedTendersVar';

export const TendersScreening: FC = () => {
  const [selectedTenders] = useSelectedTenders();
  const [tendersView, setTendersView] = useTendersViewState();
  const { data: allMps, loading: mpsLoading } = useLoadAllMps();

  const toggleView = useCallback(
    (view: PageView) => {
      setTendersView(view);
    },
    [setTendersView]
  );

  return (
    <ApiTendersProvider type={'Mp'}>
      <MpTitle />
      <div className={styles.heading}>
        <div className={styles.screeningSearch}>
          <FilterSearch />
          <TendersTotal className={styles.total} />
        </div>

        <div className={styles.headingActions}>
          <FilterStatuses />
        </div>
        {tendersView === PageView.board && (
          <div className={styles.headingActions}>
            <FilterSort />
          </div>
        )}
        <div className={styles.headingActions}>
          <ViewOptionsDropDown onToggleView={toggleView} currentView={tendersView} />
        </div>
      </div>
      <div className={styles.content}>
        {mpsLoading ? (
          <Skeleton active loading />
        ) : !!allMps?.length ? (
          <>
            {tendersView === PageView.board && (
              <>
                {!!selectedTenders.length && (
                  <div className={styles.boardActions}>
                    <OverviewBoardActionsMultiple />
                  </div>
                )}
                <TendersBoard />
              </>
            )}
            {tendersView === PageView.table && <TendersList />}
          </>
        ) : (
          <EmptyMatchingProfilesList />
        )}
      </div>
      <OverviewSidebars />
    </ApiTendersProvider>
  );
};
TendersScreening.displayName = 'TendersScreening';

export default TendersScreening;
